module.exports = __webpack_public_path__ + "Introduction-5345fa75b2f5e7f6b76d659dc5ab2b4e.png";